'use client';

import { CubeIcon, FireIcon, LeafIcon } from '@/components/icons';

type TaggedProduct = {
  is_new?: boolean;
  is_popular?: boolean;
  is_riceless?: boolean;
  is_scorched?: boolean;
  is_mini?: boolean;
  spiciness?: string;
};

// Keep the catalogue's labels and priority. New arrivals are deliberately text-only.
const stickers = {
  new: { label: 'Новинка', Icon: null },
  popular: { label: 'Хит', Icon: null },
  riceless: { label: 'Без риса', Icon: LeafIcon },
  scorched: { label: 'Опалённый', Icon: FireIcon },
  mini: { label: 'Мини', Icon: CubeIcon },
};

export function ProductStickers({ product }: { product: TaggedProduct }) {
  const variant = product.is_popular
    ? 'popular'
    : product.is_new
      ? 'new'
      : product.is_riceless
        ? 'riceless'
        : product.is_scorched
          ? 'scorched'
          : product.is_mini
            ? 'mini'
            : null;
  const sticker = variant ? stickers[variant] : null;

  return (
    <div className="product-stickers">
      {sticker && (
        <span
          className={`product-sticker sticker-${variant}`}
          role="img"
          aria-label={sticker.label}
          title={sticker.label}
        >
          <img
            className="sticker-body"
            src="/storefront/sticker-resin-body-v3.webp"
            width={640}
            height={218}
            alt=""
            aria-hidden="true"
            draggable={false}
          />
          {variant === 'popular' ? (
            <span className="sticker-icon sticker-icon-render" aria-hidden="true">
              <img
                src="/storefront/sticker-lightning-v3.webp"
                width={160}
                height={283}
                alt=""
                draggable={false}
              />
            </span>
          ) : (
            sticker.Icon && (
              <span className="sticker-icon" aria-hidden="true">
                <sticker.Icon size={15} weight="fill" />
              </span>
            )
          )}
          <span className="sticker-label" aria-hidden="true">
            {sticker.label}
          </span>
        </span>
      )}
      {product.spiciness === 'spicy' && (
        <span
          className="product-sticker sticker-spicy"
          role="img"
          aria-label="Острое"
          title="Острое"
        >
          <img
            className="sticker-pepper"
            src="/storefront/sticker-pepper-v3.webp"
            width={160}
            height={131}
            alt=""
            aria-hidden="true"
            draggable={false}
          />
        </span>
      )}
    </div>
  );
}
